'use client';

/**
 * Subset of `CtaAnalytics` in `@cc-shopping/platform-analytics`.
 */
import { c as _c } from "react/compiler-runtime";
export type DirectToApplicationAnalyticsProps = {
  marketplacePayload?: {
    destination_url?: string;
    [key: string]: unknown;
  };
};
import { useSlug } from '@cc-shopping/hooks/useSlug';
import { theme } from '@cc-shopping/ui/theme';
import { useMediaQuery } from '@mui/material';
import { CHASE_DIRECT_OFFER_IDS, CHASE_SAPPHIRE_RESERVE_OFFER_ID, CHASE_SR_DIRECT_LINK_SLUGS } from './constants';
import { addDirectToApplicationParam } from './server';
const isChaseMonetizingMobile = ({
  id,
  isMonetizing,
  isMobile
}: {
  id: string;
  isMonetizing: boolean;
  isMobile: boolean;
}) => isMobile && isMonetizing && CHASE_DIRECT_OFFER_IDS.includes(id);
const isChaseSRDirectLink = ({
  id,
  isMonetizing,
  slug
}: {
  id: string;
  isMonetizing: boolean;
  slug: string;
}) => isMonetizing && CHASE_SR_DIRECT_LINK_SLUGS.includes(slug) && CHASE_SAPPHIRE_RESERVE_OFFER_ID === id;
const shouldApplyChaseDirectLink = ({
  id,
  isMonetizing,
  isMobile,
  slug
}: {
  id: string;
  isMonetizing: boolean;
  isMobile: boolean;
  slug: string;
}) => isChaseMonetizingMobile({
  id,
  isMonetizing,
  isMobile
}) || isChaseSRDirectLink({
  id,
  isMonetizing,
  slug
});
export const useDirectLinkOffer = t0 => {
  const $ = _c(17);
  const {
    analytics,
    offer
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = theme.breakpoints.down("md");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  const slug = useSlug();
  if (!shouldApplyChaseDirectLink({
    id: offer.id,
    isMonetizing: offer.details.isMonetizing,
    isMobile,
    slug
  })) {
    let t2;
    if ($[1] !== analytics || $[2] !== offer) {
      t2 = {
        analytics,
        offer
      };
      $[1] = analytics;
      $[2] = offer;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== analytics || $[5] !== offer.details.applyLink || $[6] !== offer.details.directApplyLink) {
    t2 = !analytics.marketplacePayload ? analytics : {
      ...analytics,
      marketplacePayload: {
        ...analytics.marketplacePayload,
        destination_url: offer.details.directApplyLink ?? offer.details.applyLink
      }
    };
    $[4] = analytics;
    $[5] = offer.details.applyLink;
    $[6] = offer.details.directApplyLink;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = offer.details.directApplyLink ?? offer.details.applyLink;
  let t4;
  if ($[8] !== offer.details || $[9] !== t3) {
    t4 = {
      ...offer.details,
      applyLink: t3
    };
    $[8] = offer.details;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== offer || $[12] !== t4) {
    t5 = {
      ...offer,
      details: t4
    };
    $[11] = offer;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t5) {
    t6 = {
      analytics: t2,
      offer: t5
    };
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const useApplyLinkForDirectLink = t0 => {
  const $ = _c(3);
  const {
    offerId,
    originalApplyLink,
    isMonetizing
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = theme.breakpoints.down("md");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  const slug = useSlug();
  if (!shouldApplyChaseDirectLink({
    id: offerId,
    isMonetizing,
    isMobile,
    slug
  })) {
    return originalApplyLink;
  }
  let t2;
  if ($[1] !== originalApplyLink) {
    t2 = addDirectToApplicationParam(originalApplyLink);
    $[1] = originalApplyLink;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};